import { render, staticRenderFns } from "./CourseGoodsDetail.vue?vue&type=template&id=0fe55fd0&"
import script from "./CourseGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./CourseGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseGoodsDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports